import { RedoTextInput } from "../../../arbiter-components/input/redo-text-input";

export function BxgyMaxUsesPerOrderField({
  value,
  setValue,
}: {
  value: number | undefined;
  setValue: (value: number | undefined) => void;
}) {
  return (
    <RedoTextInput
      inputTypeHint="number"
      label="Maximum uses per order"
      placeholder="Unlimited"
      setValue={(value) => {
        setValue(value ? Number(value) : undefined);
      }}
      value={value?.toString() || ""}
    />
  );
}
